import client from './client';

export const getPurchaseInvoicesPaginated = (params) =>
  client.get('/purchase-invoices', { params }).then((r) => r.data);

export const getPurchaseInvoice = (uuid) =>
  client.get(`/purchase-invoices/${uuid}`).then((r) => r.data);

export const createPurchaseInvoice = (data) =>
  client.post('/purchase-invoices', data).then((r) => r.data);

export const receiveGoods = (uuid, data) =>
  client.post(`/purchase-invoices/${uuid}/receive`, data).then((r) => r.data);

export const updatePurchaseInvoice = (uuid, data) =>
  client.patch(`/purchase-invoices/${uuid}`, data).then((r) => r.data);

export const updatePaymentStatus = (uuid, paymentStatus, businessUuid) =>
  client
    .patch(`/purchase-invoices/${uuid}/payment-status`, {
      paymentStatus,
      businessUuid,
    })
    .then((r) => r.data);

export const deletePurchaseInvoice = (uuid, businessUuid) =>
  client
    .delete(`/purchase-invoices/${uuid}`, { params: { businessUuid } })
    .then((r) => r.data);

export const importInvoice = (formData) =>
  client
    .post('/purchase-invoices/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data);
